module.exports = __webpack_public_path__ + "static/img/card-title4.c781c5f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/weicai/weTech/card-title4.png
// module id = g4op
// module chunks = 2